import Vue from 'vue'
import VueRouter from 'vue-router'
import RouterConfig from './modules'
import CommonRouters from './common'

Vue.use(VueRouter)

const routes = RouterConfig.concat(CommonRouters)
const router = new VueRouter({
  mode: 'history',
  routes,
})

const whiteList = ['/login']

// router.beforeEach((to, from, next) => {
//   const userData = sessionStorage.getItem('userData')
//   const { token } = userData ? JSON.parse(userData) : {}

//   if (token) {
//     if (to.path === '/login') {
//       next('/')
//     } else {
//       next()
//     }
//   } else {
//     // 未登录
//     if (whiteList.includes(to.path)) {
//       next()
//     } else {
//       next('/login')
//     }
//   }
// })

export default router
